<script lang="ts">
  import Icon from "../../common/icons/Icon.svelte";
  import type { ProgressStep, CreateNewAccountPageName } from "./type";

  export let currentStep: number = 1;
  export let maxSteps: number = 3;
  export let goToPage: (page: CreateNewAccountPageName) => void;
  export let progressSteps: ProgressStep[];

  function updateComponent(currentStep: number, maxSteps: number) {
    const result: { id: number; active: boolean }[] = [];

    for (let i = 0; i < maxSteps; i++) {
      result.push({
        id: i,
        active: currentStep > i,
      });
    }

    return result;
  }

  function handleStepClick(stepInfo: ProgressStep) {
    if (stepInfo.canNavigate) {
      goToPage(stepInfo.pageName);
    }
  }

  $: components = updateComponent(currentStep, maxSteps);
</script>

<div class="w-full h-1.5 flex flex-row gap-2">
  {#each components as comp, index (comp.id)}
    {@const stepInfo = progressSteps[index] || null}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div
      class="progress-item"
      class:finish={stepInfo.finish}
      on:click={() => handleStepClick(stepInfo)}
    >
      <div class="progress-indicator" class:active={comp.active} />
      {#if stepInfo}
        <div class="progress-info">
          <div class="label">{stepInfo.label}</div>
          <div class="icon"><Icon icon="circle-tick" size="14px" /></div>
        </div>
      {/if}
    </div>
  {/each}
</div>

<style lang="postcss">
  .progress-item {
    @apply relative py-0.5 flex-grow cursor-pointer;
  }

  .progress-indicator {
    @apply relative w-full h-0.5 bg-light-100 z-10;
  }

  .progress-indicator.active {
    @apply bg-primary-indigo-blue;
  }

  .progress-info {
    @apply hidden;
  }

  .progress-item:hover .progress-info {
    @apply absolute -top-1 -left-1 -right-1;
    @apply flex flex-row items-center justify-between px-3 pt-4 pb-2.5 bg-white rounded-b z-0;
    box-shadow: 1px 2px 10px rgba(55, 84, 170, 0.16);
  }

  .progress-item .label {
    @apply text-dark-100 font-medium;
  }

  .progress-item.finish .label {
    @apply text-primary-indigo-blue;
  }

  .progress-item .icon {
    @apply text-light-200;
  }

  .progress-item.finish .icon {
    @apply text-tertiary-success;
  }
</style>
